import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`loyalty-tabpanel-${index}`}
      aria-labelledby={`loyalty-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

const LoyaltyPoints = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  // Dummy data for Point Earning Rules
  const [earningRules] = useState([
    {
      id: 1,
      ruleName: "Purchase Reward",
      actionTrigger: "Purchase",
      pointValue: "1 point per $1 spent",
      minSpend: "$10",
      eligibleProducts: "All Products",
      activationPeriod: "01 Jan 2025 - 31 Dec 2025",
    },
    {
      id: 2,
      ruleName: "Product Review Bonus",
      actionTrigger: "Submit a Review",
      pointValue: "10 points per review",
      minSpend: "N/A",
      eligibleProducts: "All Categories",
      activationPeriod: "01 Feb 2025 - 30 Jun 2025",
    },
  ]);
  console.log("data");

  // Redemption Criteria State
  const [conversionRate, setConversionRate] = useState("");
  const [minPoints, setMinPoints] = useState("");
  const [maxRedemption, setMaxRedemption] = useState("");
  const [allowCheckout, setAllowCheckout] = useState(true);
  const [restrictProducts, setRestrictProducts] = useState(false);

  return (
    <>
      <div className="main_title">
        <h1>Loyalty Points Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Loyalty Points Management
        </p>
      </div>

      <Box className="custom_tabs1">
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
          aria-label="Loyalty Points Tabs"
          className="custom_tabs_links"
        >
          <Tab label="Point-Earning Rules" />
          <Tab label="Redemption Criteria" />
        </Tabs>
      </Box>

      <div className="cards">
        {/* TAB 1: Point-Earning Rules */}
        <TabPanel value={tabIndex} index={0}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search by rule name or trigger..."
              />
            </div>
            <div className="right_s">
              <Button className="btn btn_primary" onClick={() => navigate("add")}>
                <AddIcon /> Add Rule
              </Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No</TableCell>
                  <TableCell>Rule Name</TableCell>
                  <TableCell>Action / Trigger</TableCell>
                  <TableCell>Point Value</TableCell>
                  <TableCell>Min Spend / Threshold</TableCell>
                  <TableCell>Activation Period</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {earningRules
                  .filter(
                    (rule) =>
                      rule.ruleName
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                      rule.actionTrigger
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                  )
                  .map((rule, index) => (
                    <TableRow hover key={rule.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{rule.ruleName}</TableCell>
                      <TableCell>{rule.actionTrigger}</TableCell>
                      <TableCell>{rule.pointValue}</TableCell>
                      <TableCell>{rule.minSpend}</TableCell>
                      <TableCell>{rule.activationPeriod}</TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <IconButton onClick={() => navigate("add")}>
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Edit"
                            />
                          </IconButton>
                          <IconButton>
                            <img
                              src="/static/images/trash2_icon.svg"
                              alt="Delete"
                            />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>

        {/* TAB 2: Redemption Criteria */}
        <TabPanel value={tabIndex} index={1}>
          <div className="form">

            <div className="gap_p">
              {/* i. Redemption Conversion Rate */}
              <div className="control_group w_33">
                <label>Redemption Conversion Rate($1)</label>
                <TextField
                  placeholder="e.g., 100 points = $1"
                  fullWidth
                  value={conversionRate}
                  onChange={(e) => setConversionRate(e.target.value)}
                />
              </div>

              {/* ii. Minimum Points for Redemption */}
              <div className="control_group w_33">
                <label>Minimum Points for Redemption</label>
                <TextField
                  placeholder="Enter minimum points required"
                  fullWidth
                  value={minPoints}
                  onChange={(e) => setMinPoints(e.target.value)}
                />
              </div>

              {/* iii. Maximum Redemption Limit */}
              <div className="control_group w_33">
                <label>Maximum Redemption Limit</label>
                <TextField
                  placeholder="Enter maximum points per transaction"
                  fullWidth
                  value={maxRedemption}
                  onChange={(e) => setMaxRedemption(e.target.value)}
                />
              </div>
              <div className="control_group w_100 ">
                <label>Applicable Scenarios</label>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={allowCheckout}
                      onChange={(e) => setAllowCheckout(e.target.checked)}
                    />
                  }
                  label="Allow redemption during checkout"
                />


              </div>
            </div>

            {/* iv. Applicable Scenarios */}

            {/* Save Button */}
            <div className="form_btn">
              <Button className="btn btn_primary">Save Criteria</Button>
            </div>
          </div>
        </TabPanel>
      </div>
    </>
  );
};

export default LoyaltyPoints;
